module.exports = __webpack_public_path__ + "img/19.a0bcba9d.jpg";